import { Link } from "react-router-dom";
import AnimateOnScroll from "../AnimateOnScroll";
import heroHjem from "@/assets/hero-hjem.jpg";

const localImages: Record<string, string> = {
  "hero-hjem": heroHjem,
};

interface HeroSectionProps {
  heading: string;
  body: string;
  image?: string;
  localImage?: string;
  cta?: { label: string; href: string }[];
}

const HeroSection = ({ heading, body, image, localImage, cta }: HeroSectionProps) => {
  const imgSrc = localImage ? localImages[localImage] : image;

  const handleClick = (href: string, e: React.MouseEvent) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.getElementById(href.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <section className="relative overflow-hidden">
      {imgSrc && (
        <div className="absolute inset-0">
          <img
            src={imgSrc}
            alt=""
            aria-hidden="true"
            className="h-full w-full object-cover"
            loading="eager"
            fetchPriority="high"
            width={1470}
            height={1069}
          />
          <div className="absolute inset-0 bg-foreground/60" />
        </div>
      )}
      <div
        className={`relative mx-auto max-w-6xl px-6 py-24 md:py-36 ${
          imgSrc ? "text-primary-foreground" : ""
        }`}
      >
        <div className="max-w-2xl">
          <AnimateOnScroll>
            <h1 className="text-4xl font-bold leading-tight md:text-5xl lg:text-6xl">
              {heading}
            </h1>
          </AnimateOnScroll>
          <AnimateOnScroll delay="delay-200">
            <p className="mt-6 text-lg leading-relaxed opacity-90 font-body md:text-xl">
              {body}
            </p>
          </AnimateOnScroll>
          {cta && cta.length > 0 && (
            <AnimateOnScroll delay="delay-400">
              <div className="mt-8 flex flex-wrap gap-4">
                {cta.map((item, i) =>
                  item.href.startsWith("#") ? (
                    <a
                      key={i}
                      href={item.href}
                      onClick={(e) => handleClick(item.href, e)}
                      className={`inline-flex items-center rounded-full px-8 py-3.5 font-body font-semibold text-sm tracking-wide transition-all duration-300 cursor-pointer ${
                        i === 0
                          ? "bg-primary text-primary-foreground hover:opacity-90 hover:-translate-y-0.5 shadow-lg"
                          : "border-2 border-current hover:bg-primary-foreground/10 hover:-translate-y-0.5"
                      }`}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      key={i}
                      to={item.href}
                      className={`inline-flex items-center rounded-full px-8 py-3.5 font-body font-semibold text-sm tracking-wide transition-all duration-300 ${
                        i === 0
                          ? "bg-primary text-primary-foreground hover:opacity-90 hover:-translate-y-0.5 shadow-lg"
                          : "border-2 border-current hover:bg-primary-foreground/10 hover:-translate-y-0.5"
                      }`}
                    >
                      {item.label}
                    </Link>
                  )
                )}
              </div>
            </AnimateOnScroll>
          )}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
